import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationUserGroupRoleBindingDeleteArgs, UserRoleBinding } from "types/generated";

type UserRoleBindingDeleteData = {
  userGroupRoleBindingDelete: Pick<UserRoleBinding, "id">;
};

export const USER_GROUP_ROLE_BINDING_DELETE: TypedDocumentNode<
  UserRoleBindingDeleteData,
  MutationUserGroupRoleBindingDeleteArgs
> = gql`
  mutation UserGroupRoleBindingDelete($id: ID!) {
    userGroupRoleBindingDelete(id: $id) {
      id
    }
  }
`;
